import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Heart, Menu, X } from 'lucide-react';
import navItems from '../data/navItems';
import logoImg from './Realm_of_Love_Logo_ADJUSTED-removebg-preview.png';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        <button className="nav-logo" onClick={() => handleNavigate('/')} aria-label="Go to homepage">
          <img src={logoImg} alt="Realm of Love Foundation logo" style={{ height: 120, width: 'auto' }} />
        </button>

        <div className="nav-links">
          {navItems.map(item => (
            <button
              key={item.id}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleNavigate(item.path)}
            >
              {item.label}
            </button>
          ))}
          <button className="btn btn-primary btn-sm" onClick={() => handleNavigate('/donate')}>
            <Heart size={16} /> Donate
          </button>
        </div>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <button
          className="mobile-menu-close"
          onClick={() => setMobileMenuOpen(false)}
          aria-label="Close menu"
        >
          <X size={28} />
        </button>
        {navItems.map(item => (
          <button
            key={item.id}
            className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => handleNavigate(item.path)}
          >
            {item.label}
          </button>
        ))}
        <button
          className="btn btn-primary"
          onClick={() => handleNavigate('/donate')}
          style={{ marginTop: '1rem' }}
        >
          <Heart size={16} /> Donate Now
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
